export interface CurrencyMeta {
  code: string;
  name: string;
  symbol?: string;
}

export interface CurrencySource {
  title?: string;
  name?: string;
  url?: string;
  domain?: string;
}

export interface CurrencyResult {
  kind: "currency";
  mode?: "conversion" | "today";
  deterministic?: boolean;
  grounded?: boolean;
  amount: string;
  from: CurrencyMeta;
  to: CurrencyMeta;
  rate: string;
  inverse_rate: string;
  converted_amount: string;
  display_input: string;
  display_result: string;
  provider?: string;
  provider_updated_at?: string | null;
  source?: CurrencySource;
  sources?: CurrencySource[];
  ngn_reference?: {
    code: "NGN";
    name: string;
    amount: string;
    display: string;
    rate: string;
    provider?: string;
    source_name?: string;
    source_url?: string;
    provider_updated_at?: string | null;
  } | null;
  indicative?: boolean;
}

export interface SupportedCurrency {
  code: string;
  name: string;
}

export function escapeCurrencyHtml(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function formatCurrencyNumber(value: string | number): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value ?? "");

  const abs = Math.abs(n);
  if (abs >= 1e12) return `${(n / 1e12).toLocaleString(undefined, { maximumFractionDigits: 2 })} trillion`;
  if (abs >= 1e9) return `${(n / 1e9).toLocaleString(undefined, { maximumFractionDigits: 2 })} billion`;
  if (abs >= 1e6) return `${(n / 1e6).toLocaleString(undefined, { maximumFractionDigits: 2 })} million`;
  if (abs >= 1000) return n.toLocaleString(undefined, { maximumFractionDigits: 4 });
  if (abs > 0 && abs < 0.01) return n.toLocaleString(undefined, { maximumSignificantDigits: 6 });
  return n.toLocaleString(undefined, { maximumFractionDigits: 6 });
}

export function formatProviderTime(value?: string | null): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
